<template>

</template>
<script>
export default {
  mounted() {
    location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4203041b4afd41f7&redirect_uri=http://app.baoshanhszh.cn/contributeMoney/home&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
  }
};
</script>